import { lazy } from 'react';
import { useLocation } from 'react-router-dom';
import { routesConfig } from "../configs/routes";
import type { CommonType } from '../../shared/types/CommonType';

const Blank = lazy(() => import('./components/Blank'));

const PreLoginLayout = ({ children }: CommonType) => {
  const location = useLocation();
  const { pathname } = location;

  const isAuthPath = routesConfig.filter(route => !route.isProtected).some((route) => route.path === pathname);

  return (
    <>
      {isAuthPath ? <Blank>{children}</Blank> : children}
    </>
  )
};

export default PreLoginLayout;